// :: Dependencies
import {
  ORDERS_INFO_GET,
  ASC_DATE_FILTER,
  DESC_DATE_FILTER,
  ASC_NUMBER_FILTER,
  DESC_NUMBER_FILTER,
  ORDER_LAST_DOCUMENT_SAVE
} from "./mutation-types";
import { errorMessage } from "@/services/MessageService";
import { firestore, firestoreDb, firestoreField } from "@/config/firebase";
import { loaderDone, loaderStart } from "@/services/LoaderService";

export default {
  async obtenerPedidos({ commit, dispatch }, { orderType, lastDocument }) {
    loaderStart();
    try {
      const branchOffices = await dispatch("getBranchOfficesAccess");
      let query = firestoreDb
        .collectionGroup("order")
        .orderBy("lastUpdate", "desc");
      if (orderType != "all") {
        query = firestoreDb
          .collectionGroup("order")
          .orderBy("lastUpdate", "desc")
          .where("status", "in", [`${orderType}Output`, `${orderType}Input`]);
      }
      for (const branchOffice of branchOffices) {
        query.where("branch", "==", branchOffice);
      }
      if (lastDocument) {
        query = firestoreDb
          .collectionGroup("order")
          .orderBy("lastUpdate", "desc")
          .startAfter(lastDocument);

        if (orderType != "all") {
          query = firestoreDb
            .collectionGroup("order")
            .orderBy("lastUpdate", "desc")
            .where("status", "in", [`${orderType}Output`, `${orderType}Input`])
            .startAfter(lastDocument);
        }
      }
      const orders = await query.limit(10).get();
      let newLastDocument = orders.docs[orders.docs.length - 1];
      if (
        (lastDocument &&
          newLastDocument &&
          newLastDocument.id !== lastDocument.id) ||
        !lastDocument
      ) {
        commit(ORDER_LAST_DOCUMENT_SAVE, newLastDocument);
        const pedidosArray = [];
        let totalResults = 0;
        for await (const order of orders.docs) {
          const damageOrderDoc = order.ref.parent.parent.id;
          const damageOrderData = await firestore("damages")
            .doc(damageOrderDoc)
            .get();
          pedidosArray.push({
            key: damageOrderData.id,
            id: damageOrderData.data().id,
            status: order.data().status,
            date: damageOrderData.data().date.toDate(),
            saleOrderID: damageOrderData.data().saleOrderID
          });
          totalResults += 1;
        }
        commit(ORDERS_INFO_GET, {
          pedidos: pedidosArray,
          totalResults: totalResults,
          keepPrevios: lastDocument !== undefined
        });
        return pedidosArray.length;
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error inesperado en el filtro de pedidos");
      loaderDone();
    }
  },
  getBranchOfficesAccess({ rootState }) {
    const mapBranch = {
      1: "corporativo",
      18: "toluca",
      19: "aguascalientes",
      20: "coatzacoalcos",
      21: "cuatitlan",
      22: "cuernavaca",
      23: "guadalajara",
      24: "tizayuca",
      25: "merida",
      26: "monterrey",
      27: "puebla",
      28: "salitre",
      29: "potosi",
      30: "Sanitarios",
      31: "silao",
      33: "veracruz",
      36: "chiapa"
    };
    const userAccess = rootState.user.userAccess;
    const arrayBranchOfficesAccess = [];
    Object.keys(userAccess).map(key => {
      if (key.includes("damage-read-sucursal")) {
        if (userAccess[key]) {
          Object.keys(mapBranch).map(keyBranch => {
            if (key.includes(mapBranch[keyBranch])) {
              if (!arrayBranchOfficesAccess.includes(keyBranch))
                arrayBranchOfficesAccess.push(parseInt(keyBranch));
            }
          });
        }
      }
    });
    return arrayBranchOfficesAccess;
  },
  filterDateAsc({ commit }) {
    commit(ASC_DATE_FILTER);
  },
  filterDateDesc({ commit }) {
    commit(DESC_DATE_FILTER);
  },
  filterNumAsc({ commit }) {
    commit(ASC_NUMBER_FILTER);
  },
  filterNumDesc({ commit }) {
    commit(DESC_NUMBER_FILTER);
  },
  async updateOrderStatus(_, { productRef, status, correctStatus }) {
    switch (status) {
      case "deliveryOutput":
        productRef.update({
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          status: "deliveryInput",
          "statusMap.delivery.output": true
        });
        break;
      case "deliveryInput":
        productRef.update({
          status: "completed",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.delivery.input": true
        });
        break;
      case "maintenanceOutput":
        productRef.update({
          status: "maintenanceInput",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.maintenance.output": true
        });
        break;
      case "maintenanceInput":
        productRef.update({
          status: "completed",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.maintenance.input": true
        });
        break;
      case "recollectionOutput":
        productRef.update({
          status: "recollectionInput",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.recollection.output": true
        });
        break;
      case "recollectionInput":
        productRef.update({
          status: "completed",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.recollection.input": true
        });
        break;
      case "relocationOutput":
        productRef.update({
          status: "relocationInput",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.relocation.output": true
        });
        break;
      case "relocationInput":
        productRef.update({
          status: "completed",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.relocation.input": true
        });
        break;

      case "rented-serviceOutput":
        productRef.update({
          status: "rented-serviceInput",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.rentedService.output": true
        });
        break;
      case "rented-serviceInput":
        productRef.update({
          status: "completed",
          lastUpdate: firestoreField.serverTimestamp(),
          correctStatus,
          "statusMap.rentedService.input": true
        });
        break;
    }
  }
};
